import { Box, styled } from '@mui/system';

export const ShadowBox = styled(Box)(({ theme }) => ({
  boxSizing: 'border-box',
  boxShadow: `0px 3px 8px ${theme.palette.boxshadow.grey}`,
  borderRadius: theme.spacing(1),
  marginBottom: theme.spacing(4),
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(2),
  background: 'rgba(204, 228, 255, 0.5)',
  height: '300px',
}));
